import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as actions from '../../../actions'
import Avatar from '../../shared/Avatar'
import NavModal from './NavModal'
import styles from '../../../constants/styles'
import OptimizedImage from '../../shared/OptimizedImage'

import { PageLoadingCircularProgress } from '../icons/CircularProgress'

class AmbassadorTopNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  // TODO fix
  // eslint-disable-next-line complexity
  render() {
    const { viewer, isLoggedIn, logOut, login } = this.props
    const { showModal } = this.state
    return (
      <Container>
        <Content>
          <Link href={login ? '/' : '/dashboard/home'}>
            <FullLogo
              size="120"
              src="../../static/abillion-logo-black.svg"
              alt="abillion logo"
              title="abillion"
            />
          </Link>
          {/* DESKTOP VERSION HAS AVATAR, WITH DROPDOWN. DROPDOWN ONLY HAS MAIN SITE PROFILE AND LOGOUT BUTTONS */}
          {isLoggedIn && !viewer.username && <PageLoadingCircularProgress />}
          {isLoggedIn && viewer.username && (
            <AvatarContainer
              onClick={(e) => {
                e.stopPropagation()
                this.setState({ showModal: !showModal })
              }}
            >
              <Avatar user={viewer} width="48px" height="48px" />
            </AvatarContainer>
          )}
          {/* MOBILE VERSION HAS MENU BUTTON. DROPDOWN SHOWS TABS TO NAVIGATE TO, AS WELL AS MAIN SITE PROFILE / LOGOUT BUTTONS */}
          <MenuButton
            onClick={(e) => {
              e.stopPropagation()
              this.setState({ showModal: !showModal })
            }}
          >
            Menu
          </MenuButton>

          {viewer.username && showModal && (
            <NavModal
              username={viewer.username}
              closeModal={() => this.setState({ showModal: false })}
              logOut={logOut}
            />
          )}
        </Content>
      </Container>
    )
  }
}

AmbassadorTopNav.propTypes = {
  viewer: PropTypes.objectOf(PropTypes.any).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  login: PropTypes.bool,
  logOut: PropTypes.func
}
AmbassadorTopNav.defaultProps = {
  viewer: {}
}

const mapStateToProps = (state) => ({
  viewer: state.users.all[state.users.viewer._id],
  isLoggedIn: state.auth.isLoggedIn
})

const mapDispatchToProps = (dispatch) => ({
  logOut: () => {
    dispatch(actions.logOut())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AmbassadorTopNav)

const Container = styled.div`
  z-index: 100;
  position: sticky;
  top: 0;
`

const Content = styled.nav`
  width: 100%;
  height: 64px;
  z-index: 100;
  background-color: ${styles.colors.white};
  border-bottom: 1px solid ${styles.colors.lightGrey};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${styles.padding.large};
`

const FullLogo = styled(OptimizedImage)`
  display: block;
  cursor: pointer;
  height: 64px;
  width: 120px;
  min-width: 120px;
  object-fit: contain;
`

const AvatarContainer = styled.div`
  cursor: pointer;
  position: relative;

  @media (max-width: 900px) {
    display: none;
  }
`

const MenuButton = styled.button`
  background: ${styles.colors.black};
  color: ${styles.colors.white};
  padding: ${styles.padding.small};
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;

  @media (min-width: 901px) {
    display: none;
  }
`
